module.exports = __webpack_public_path__ + "static/media/carrorama-duvida.9ebf5836.webp";